import { cssX, FCX, getRem } from "@datassential/platform-ui-lib";
import { IOption } from "@models";
import { Select } from "@components/Select";
import cn from "classnames";
import { useMemo } from "react";
import { FieldProps } from "@components/Field/Field";

const SelectUserBrand: FCX<{
    value: number[];
    setValue: (value: number[]) => void;
    options: IOption<number>[];
    keepOrder?: boolean;
    placeholder?: string;
    disabled?: boolean;
    isMulti?: boolean;
}> = ({
    value,
    setValue,
    options: rawOptions,
    placeholder = "Select a brand",
    isMulti,
    keepOrder,
    disabled,
}) => {
    const options = useMemo(
        () => {
            if (keepOrder) {
                return rawOptions;
            }

            return [...rawOptions].sort(
                (a, b) => a.title.localeCompare(b.title)
            );
        },
        [rawOptions, keepOrder]
    );

    const fieldModifiers = useMemo(
        () => {
            const result: FieldProps['modifiers'] = ["transparent"];

            if (value.length > 0) {
                result.push('active');
            }

            return result
        },
        [value.length]
    );

    const dropdownProps = useMemo(
        () => ({
            isInPortal: false,
            place: "right-start",
            style: {
                maxHeight: getRem(350),
                overflowX: 'hidden',
                width: getRem(250),
            },
        }),
        []
    );

    return (
        <div
            className={cn(
                cssX("Dropdown__item"),
            )}
            style={{ paddingInline: 0}}
        >
            <Select
                value={value}
                setValue={setValue}
                options={options}
                placeholder={placeholder}
                hasSearch
                allowUnselect
                moveSelectedToTop={!isMulti}
                isMulti={isMulti}
                hasToggle={isMulti}
                addCheckMarks={!isMulti}
                disabled={disabled}
                fieldProps={{
                    modifiers: fieldModifiers,
                }}
                dropdownProps={dropdownProps}
                style={{
                    position: 'relative' as const,
                    zIndex: 2,
                }}
            />
        </div>
    );
}

export default SelectUserBrand;